import { render, staticRenderFns } from "./showCaseChip.vue?vue&type=template&id=43bbb0cc&scoped=true"
import script from "./showCaseChip.vue?vue&type=script&lang=js"
export * from "./showCaseChip.vue?vue&type=script&lang=js"
import style0 from "./showCaseChip.vue?vue&type=style&index=0&id=43bbb0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bbb0cc",
  null
  
)

export default component.exports